import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import type { GoodsReceiptTotals } from "../../types"

import { formatNumber } from "@/utils/number"

interface CountBoxProps {
  label: string
  value: string
  className?: string
  "data-testid": string
}

const CountBox: FC<CountBoxProps> = ({ label, value, className, "data-testid": testId }) => {
  return (
    <Box
      className={twMerge(
        "flex h-20 flex-col justify-center rounded-md border border-gray-400 bg-gray-100 px-6 py-1",
        className
      )}
      data-testid={testId}
    >
      <Typography variant='caption' component='span' className='text-primary'>
        {label}
      </Typography>
      <Typography variant='h6' component='span' className='font-bold text-gray-700'>
        {value}
      </Typography>
    </Box>
  )
}

interface GoodsReceiptDetailsSubtotalsProps {
  label: string
  totals: GoodsReceiptTotals
}

export const GoodsReceiptDetailsSubtotals: FC<GoodsReceiptDetailsSubtotalsProps> = ({ label, totals }) => {
  const { palletsCount, unitsCount, quantity } = totals

  return (
    <Box className='flex items-end justify-end gap-6' data-testid='estimated-total-section'>
      <Typography variant='subtitle2' component='div' className='mb-5 font-bold text-gray-800'>
        {label}
      </Typography>
      <Box className='flex items-center gap-6'>
        <CountBox label='Pallets' value={String(palletsCount)} className='min-w-[92px]' data-testid='total-pallets' />
        <CountBox label='Units' value={String(unitsCount)} className='min-w-[92px]' data-testid='total-units' />
        <CountBox
          label='Total UoM'
          value={quantity === null ? "-" : formatNumber(quantity)}
          className='min-w-[152px]'
          data-testid='total-weight'
        />
      </Box>
    </Box>
  )
}
